<script setup lang="ts">
import type { PresentableAircraft } from "@ca/types/aircraft";

import { computed, ref } from "vue";

import { useEventBus } from "@vueuse/core";

import DateRangePicker from "@/components/DateRangePicker.vue";

import AircraftAvatar from "./AircraftAvatar.vue";
import AircraftFlightsList from "./AircraftFlightsList.vue";
import AircraftStats from "./AircraftStats.vue";
import AircraftTopMissions from "./AircraftTopMissions.vue";
import HomeAirport from "./HomeAirport.vue";
const props = defineProps<{
	pac: PresentableAircraft
}>();

const bus = useEventBus<PresentableAircraft>("aircraft-panel");

const enabled = ref(false);

const open = ref(false);

const handleOpen = (e: Event) => {
	open.value = true;
	e.stopPropagation();
};

const aircraft = ref<PresentableAircraft | null>(null);
bus.on((e) => {
	if (e.id === props.pac.id) {
		open.value = true;
		aircraft.value = e;
	}
});

const aircraftId = computed(() => {
	return props.pac.id ?? aircraft.value?.id ?? props.pac.tailNumber;
});
const queryKeys = computed(() => {
	return [
		["flights", aircraftId.value],
		["missions", aircraftId.value],
		["stats", aircraftId.value],
	];
});
</script>
  
<template>
  <USlideover
    v-model:open="open"
    side="right"
    :ui="{
      title: 'w-92',
    }"
  >
    <UButton
      label="Details"
      size="sm"
      @mousedown="enabled = true"
      @click="handleOpen"
    />

    <template #title>
      <div class="flex items-center gap-4 justify-between w-full">
        <AircraftAvatar
          :key="pac.id"
          :aircraft="pac"
        />
        <div class="flex flex-col text-grey-400">
          <DateRangePicker
            :query-keys="queryKeys"
          />
        </div>
      </div>
    </template>
  
    <template #body>
      <section>
        <div class="flex flex-col mb-6">
          <HomeAirport :aircraft-id="aircraftId" />
          <USeparator class="my-8" /> 
          <AircraftStats :aircraft-id="aircraftId" />
        </div>
        <USeparator class="my-8" />
        <h3 class="font-cta text-brand-500 text-xl mb-4">
          Flights
        </h3>
        <AircraftFlightsList
          :latest="true"
          :aircraft-id="aircraftId"
          class="mt-4"
        />
        <USeparator class="my-8" />
        <AircraftTopMissions
          :aircraft-id="aircraftId"
        />
      </section>
    </template>
  </USlideover>
</template>